export const getArrowId = (uid: string, direction: 'prev' | 'next') =>
  `timeline-${uid}-${direction}`;
